const NO_RIGHTS_PAGE = 'NO_RIGHTS_PAGE';

const initialState = {
  noRights: false,
};

export function changeRights(data) {
  return {
    type: NO_RIGHTS_PAGE,
    payload: data,
  };
}

export default function rightsInfo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'NO_RIGHTS_PAGE':
      return Object.assign({}, state, {
        noRights: payload,
      });
    default:
      return state;
  }
}
